export default [
  {
    title: 'Home',
    route: 'home',
    icon: 'HomeIcon',
  },
  {
    title: 'ثبت تردد',
    icon: 'CheckIcon',
    route: 'tick-map',
  },
  {
    title: 'گزارش ترددها',
    icon: 'ListIcon',
    route: 'record-list-personal',
  },
]
